module.exports = [
	{ no: '14', name: 'ยุทธการ' },
	{ no: '15', name: 'ผู้ทำการในอากาศ' },
	{ no: '16', name: 'ผู้บังคับอากาศยานไร้คนขับ' },
	{ no: '17', name: 'ควบคุมการปฏิบัติทางอากาศ' },
	{ no: '18', name: 'ปฏิบัติการทางอวกาศ' },
	{ no: '24', name: 'นิรภัย' },
	{ no: '25', name: 'อุตุนิยมวิทยา' },
	{ no: '26', name: 'วิทยาศาสตร์' },
	{ no: '27', name: 'สารสนเทศและสงครามอิเล็กทรอนิกส์' },
	{ no: '28', name: 'ไซเบอร์' },
	{ no: '30', name: 'สื่อสารอิเล็กทรอนิกส์' },
	{ no: '32', name: 'สรรพาวุธ' },
	{ no: '43', name: 'ช่างอากาศ' },
	{ no: '44', name: 'ส่งกำลังบำรุง' },
	{ no: '55', name: 'ช่างโยธา' },
	{ no: '57', name: 'แผนที่' },
	{ no: '60', name: 'ขนส่ง' },
	{ no: '62', name: 'พลาธิการ' },
	{ no: '64', name: 'พัสดุ' },
	{ no: '67', name: 'การเงิน' },
	{ no: '68', name: 'ปลัดบัญชี' },
	{ no: '69', name: 'ตรวจสอบภายใน' },
	{ no: '70', name: 'สารบรรณ' },
	{ no: '71', name: 'ลาดตระเวนทางอากาศและภูมิสารสนเทศ' },
	{ no: '73', name: 'กำลังพล' },
	{ no: '74', name: 'สวัสดิการ' },
	{ no: '75', name: 'การศึกษาและการฝึก' },
	{ no: '76', name: 'ดุริยางค์' },
	{ no: '77', name: 'สารวัตร' },
	{ no: '78', name: 'อากาศโยธิน' },
	{ no: '80', name: 'การข่าวกรอง' },
	{ no: '81', name: 'กิจการพลเรือนและประชาสัมพันธ์' },
	{ no: '88', name: 'พระธรรมนูญ' },
	{ no: '89', name: 'อนุศาสนาจารย์' },
	{ no: '90', name: 'บริการแพทย์' },
	{ no: '91', name: 'ผู้ชำนาญการแพทย์เฉพาะอย่าง' },
	{ no: '92', name: 'เภสัชกร' },
	{ no: '93', name: 'แพทย์' },
	{ no: '94', name: 'แพทย์' },
	{ no: '95', name: 'แพทย์' },
	{ no: '97', name: 'พยาบาล' },
	{ no: '98', name: 'ทันตแพทย์' },
	{ no: '99', name: 'เวชศาสตร์การบิน' },
	{ no: '100', name: 'นักบิน' },
	{ no: '101', name: 'แพทย์' }
];